import { render } from "./PodAdd.vue?vue&type=template&id=965d4578&scoped=true"
import script from "./PodAdd.vue?vue&type=script&lang=js"
export * from "./PodAdd.vue?vue&type=script&lang=js"

import "./PodAdd.vue?vue&type=style&index=0&id=965d4578&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-965d4578"]])

export default __exports__